import { render, staticRenderFns } from "./BalanceSpendChart.vue?vue&type=template&id=308c2c36&scoped=true"
import script from "./BalanceSpendChart.vue?vue&type=script&lang=js"
export * from "./BalanceSpendChart.vue?vue&type=script&lang=js"
import style0 from "./BalanceSpendChart.vue?vue&type=style&index=0&id=308c2c36&prod&lang=scss"
import style1 from "./BalanceSpendChart.vue?vue&type=style&index=1&id=308c2c36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308c2c36",
  null
  
)

export default component.exports